import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  IDeferredMixin,
  ICardId,
  ICardData,
  ACTION_ADD,
  ACTION_REMOVE,
  Item,
  Items,
  NAME,
} from './types';

const deferred = namespace(NAME);

@Component
export default class DeferredMixin extends Vue implements IDeferredMixin {
  @deferred.State items: Items;
  @deferred.Action(ACTION_ADD) add: (item: Item) => void;
  @deferred.Action(ACTION_REMOVE) remove: (id: Item['id']) => void;

  saved({ id }: ICardId): boolean {
    return this.items.findIndex((item) => item.id === id) >= 0;
  }

  toggle(data: ICardData): void {
    if (this.saved(data)) return this.remove(data.id);
    this.add(data);
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/mixins/DeferredMixin.ts